import type { ApiConfig } from '@api/types';
import { typedMethodPostWithRequiredParams, typedMethodGet } from '@api/utils';
import type { AcquireEntityDetailsFromReplicaResponseDto } from '@api/generated/models';
import type { AcquireEntityDetailsParams, GetErpFieldsParams } from './types';

import type {
  AcquireEntityDetailsFromReplicaResponse,
  ErpFieldsResponse,
} from '../../domain/types';

import {
  toAcquireEntityDetailsFromReplicaResponse,
  toErpFieldsResponse,
} from '../../domain/mappers';

export default ({ baseURL }: ApiConfig) => ({
  acquireEntityDetailsFromReplica: typedMethodPostWithRequiredParams<
    AcquireEntityDetailsParams,
    AcquireEntityDetailsFromReplicaResponseDto,
    AcquireEntityDetailsFromReplicaResponse
  >(
    (data) =>
      fetch(`${baseURL}/v1/feed/acquireEntityDetailsFromReplica`, {
        method: 'POST',
        body: JSON.stringify({
          entityType: data.params.type,
          entityId: data.params.id,
        }),
      }),
    toAcquireEntityDetailsFromReplicaResponse
  ),
  getErpFields: typedMethodGet<GetErpFieldsParams, ErpFieldsResponse, ErpFieldsResponse>(
    (data) =>
      fetch(data.params.url, {
        method: 'GET',
        headers: {
          Accept: 'application/json;odata=fullmetadata',
          'x-ms-date': new Date().toUTCString(),
        },
        // @ts-expect-error - ignoreInterceptor is a custom property used by the app's fetch interceptor
        ignoreInterceptor: 'true',
      }),
    toErpFieldsResponse
  ),
});

// Re-export domain types for consumers
export type {
  AcquireEntityDetailsFromReplicaResponse,
  ErpFieldsResponse,
} from '../../domain/types';

// Re-export request param types (still needed for building requests)
export type { AcquireEntityDetailsParams, GetErpFieldsParams } from './types';
